import React from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import Autosuggest from 'react-autosuggest';
import { renderSuggestion, shouldRenderSuggestions } from './constants';

const PickupDropoffCard = React.memo(function PickupDropoffCard({
  state,
  onChange,
  onPickupSuggestionsFetch,
  onPickupSuggestionsClear,
  getPickupSuggestionValue,
  onPickupToggle,
  onPickupZoneChange,
  onDropoffSuggestionsFetch,
  onDropoffSuggestionsClear,
  getDropoffSuggestionValue,
  onDropoffToggle,
  onDropoffZoneChange,
  inputPropsPickup,
  inputPropsDropoff,
  errors,
}) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-teal" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-teal"><i className="fas fa-map-marker-alt" /></span>
        <span className="rx-card-title">Pick-up &amp; Drop Off</span>
      </div>
      <div className="rx-card-body">
        {/* Pick-up */}
        <div className="rx-loc-tag">
          <span className="rx-lt-dot rx-lt-dot-green" />
          <span className="rx-lt-label">Pick-up</span>
        </div>
        <div className="rx-cols-loc3">
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Google Address</label>
            <div className="rx-tog-wrap" style={{ marginTop: 4 }}>
              <label className="rx-tog">
                <input type="checkbox" checked={state.isPickupGoogleBooking} onChange={onPickupToggle} />
                <span className="rx-tog-sl" />
              </label>
            </div>
          </div>
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Location <span className="req">*</span></label>
            <div style={{ display: state.isPickupGoogleBooking ? 'none' : 'block' }}>
              <Autosuggest
                suggestions={state.pickupSuggestions}
                onSuggestionsFetchRequested={onPickupSuggestionsFetch}
                onSuggestionsClearRequested={onPickupSuggestionsClear}
                getSuggestionValue={getPickupSuggestionValue}
                renderSuggestion={renderSuggestion}
                shouldRenderSuggestions={shouldRenderSuggestions}
                inputProps={inputPropsPickup}
                highlightFirstSuggestion={true}
              />
            </div>
            <input type="text" className="rx-ff" id="pickupGoogle" placeholder="Type slowly to search" maxLength="150" style={{ display: state.isPickupGoogleBooking ? 'block' : 'none' }} />
            {errors.pickupLocation.length > 0 && <span className="rx-err">{errors.pickupLocation}</span>}
          </div>
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Zone <span className="req">*</span></label>
            <SelectBox dataSource={state.dropdownZone} placeholder="Select zone" name="pickupZoneId" defaultValue={0} value={state.pickupZoneId} displayExpr="name" valueExpr="id" onSelectionChanged={onPickupZoneChange} showClearButton={true} searchEnabled={true} />
            {errors.pickupZoneId.length > 0 && <span className="rx-err">{errors.pickupZoneId}</span>}
          </div>
        </div>
        <div className="rx-fg" style={{ display: state.isPickupGoogleBooking ? 'none' : 'block' }}>
          <label>Pick-up Address</label>
          <input type="text" className="rx-ff" name="pickupAddress" maxLength="150" value={state.pickupAddress} onChange={onChange} placeholder="Enter pick-up address" />
        </div>

        <hr style={{ margin: '12px 0', borderColor: 'var(--rx-border)' }} />

        {/* Drop Off */}
        <div className="rx-loc-tag">
          <span className="rx-lt-dot rx-lt-dot-rose" />
          <span className="rx-lt-label">Drop Off</span>
        </div>
        <div className="rx-cols-loc3">
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Google Address</label>
            <div className="rx-tog-wrap" style={{ marginTop: 4 }}>
              <label className="rx-tog">
                <input type="checkbox" checked={state.isDropoffGoogleBooking} onChange={onDropoffToggle} />
                <span className="rx-tog-sl" />
              </label>
            </div>
          </div>
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Location <span className="req">*</span></label>
            <div style={{ display: state.isDropoffGoogleBooking ? 'none' : 'block' }}>
              <Autosuggest
                suggestions={state.dropoffSuggestions}
                onSuggestionsFetchRequested={onDropoffSuggestionsFetch}
                onSuggestionsClearRequested={onDropoffSuggestionsClear}
                getSuggestionValue={getDropoffSuggestionValue}
                renderSuggestion={renderSuggestion}
                shouldRenderSuggestions={shouldRenderSuggestions}
                inputProps={inputPropsDropoff}
                highlightFirstSuggestion={true}
              />
            </div>
            <input type="text" className="rx-ff" id="dropoffGoogle" placeholder="Type slowly to search" maxLength="150" style={{ display: state.isDropoffGoogleBooking ? 'block' : 'none' }} />
            {errors.dropoffLocation.length > 0 && <span className="rx-err">{errors.dropoffLocation}</span>}
          </div>
          <div className="rx-fg" style={{ marginBottom: 0 }}>
            <label>Zone <span className="req">*</span></label>
            <SelectBox dataSource={state.dropdownZone} placeholder="Select zone" name="dropoffZoneId" defaultValue={0} value={state.dropoffZoneId} displayExpr="name" valueExpr="id" onSelectionChanged={onDropoffZoneChange} showClearButton={true} searchEnabled={true} />
            {errors.dropoffZoneId.length > 0 && <span className="rx-err">{errors.dropoffZoneId}</span>}
          </div>
        </div>
        <div className="rx-fg" style={{ display: state.isDropoffGoogleBooking ? 'none' : 'block' }}>
          <label>Drop Off Address</label>
          <input type="text" className="rx-ff" name="dropoffAddress" maxLength="150" value={state.dropoffAddress} onChange={onChange} placeholder="Enter drop off address" />
        </div>
      </div>
    </div>
  );
});

export default PickupDropoffCard;
